import { IconWithTextLockup } from '@deckee/deck-hand';

export default IconWithTextLockup;

// NOTE: until deck-hand has everything in typescript, we can't generate types so this will have to live here
export interface IconWithTextLockupProps {
  image: React.ReactNode;
  heading?: React.ReactNode | string;
  useEllipsis?: boolean;
  description?: React.ReactNode;
  descriptionColor?: string;
  flex?: string;
  breakWordsInHeading?: 'normal' | 'all' | 'words';
  emphasis?: 'description' | 'heading' | 'none';
  onClick?: () => void;
}
